import { combineReducers } from 'redux';

const memberInfoInitialState = {
  loadStatus: 0,
  data: null,
};

const infoInitialState = {
  data: null,
  loadStatus: 0,
  saveStatus: 0,
  input: {
    preset: false,
    realName: '',
    wechat: '',
    idCard: '',
    idCardImgFront: '',
    idCardImgOpposite: '',
  },
};

const invoiceProxyInitialState = {
  record: null,
  loadStatus: 0,
};

const consumeHistoryInitialState = {
  loadStatus: 0,
  data: null,
};

const eSignInitialState = {
  saveStatus: 0,
  input: {
    code: ''
  }
}

function memberInfoReducer(state = memberInfoInitialState, action) {
  switch (action.type) {
    case 'LOAD_MEMBER_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_MEMBER_INFO_COMPLETION': {
      const { data, error } = action;

      return {
        ...state,
        loadStatus: error ? 0 : 2,
        data,
      };
    }

    default:
      return state;
  }
}

function infoReducer(state = infoInitialState, action) {
  switch (action.type) {
    case 'LOAD_AGENT_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_AGENT_INFO_COMPLETION': {
      return {
        ...state,
        loadStatus: 2,
        data: action.data,
      };
    }

    case 'SYNC_AGENT_INFO_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? infoInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'APPLY_AGENT':
    case 'UPGRADE_TO_AGENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'APPLY_AGENT_COMPLETION':
    case 'UPGRADE_TO_AGENT_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
        data: {
          ...state.data,
          ...action.data,
        },
      };
    }

    default:
      return state;
  }
}

function invoiceProxyReducer(state = invoiceProxyInitialState, action) {
  switch (action.type) {
    case 'LOAD_AGENT_INVOICE_PROXY_RECORD': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_AGENT_INVOICE_PROXY_RECORD_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return { ...state, loadStatus: 0 };
      }

      return {
        ...state,
        record: data.vo,
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function consumeHistoryReducer(state = consumeHistoryInitialState, action) {
  switch (action.type) {
    case 'LOAD_CONSUME_HISTORY': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_CONSUME_HISTORY_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function eSignReducer(state = eSignInitialState, action) {
  switch (action.type) {
    case 'SAVE_AGENT_E_SIGN_EDIT': {
      return {
        ...state,
        saveStatus: 1
      }
    }
    case 'SAVE_AGENT_E_SIGN_EDIT_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2
      }
    }
    case 'SYNC_AGENT_E_SIGN_INPUT': {
      const { input, reset } = action;
      return {
        ...(reset ? eSignInitialState : state),
        input: {
          ...(reset ? eSignInitialState.input : state.input),
          ...input
        }
      }
    }
    default:
      return state;
  }
}

export default combineReducers({
  memberInfo: memberInfoReducer,
  info: infoReducer,
  invoiceProxy: invoiceProxyReducer,
  // idCard: idCardReducer,
  consumeHistory: consumeHistoryReducer,
  eSign: eSignReducer,
});
